import React from 'react'
import { useGlobalContext } from './context'
import './app.css'

const Search = () => {
  const {query,setQuery,isError}=useGlobalContext()
  return (
    <>
      <section className='search-section'>
         <h2>Search your favourite movie</h2>
         <form action='#' onSubmit={(e)=>e.preventdefault()}>
           <div>
               <input 
                     type='text' 
                     placeholder='Search here'
                     value={query}
                     onChange={(e)=>setQuery(e.target.value)} />
           </div>
         </form>
         <div>
              <p>{isError.show && isError.msg}</p>
         </div>
      </section>
    </>
  )
}

export default Search